import 'regenerator-runtime/runtime';
import ChartDataLabels from './chartjs-plugin-datalabels';
 import AppControl from './control/app.control.js';
 import dataSources from './dataSources.js';
 import controllers from './controllers';
 import initFunctions from './initFunctions';
import highLightEventDispatcher from './highlightEvent.dispatcher';

window.testDispatcher = highLightEventDispatcher;
 

let appControl = new AppControl();

appControl.init(controllers,initFunctions,dataSources);


